<agpr-dialog-container
    [id]="id"
    class="agpr-manageSavedFiltersDialog"
    [heading]="'Common.filter.manageSavedFilters'"
    [modal]="true"
    (close)="closeDialog()"
>
    <agpr-tabs>
        <agpr-tab
            [heading]="'Monitor'"
            [id]="id + '_monitorTab'"
            class="agpr-manageSavedFiltersDialog-tab"
            [agprLoading]="loading"
        >
            <div class="agpr-manageSavedFiltersDialog-searchBar">
                <agpr-text-input
                    [id]="id + '_listFilterTextInput'"
                    icon="fa-regular fa-duotone fa-magnifying-glass"
                    [bottomMargin]="false"
                    [placeholder]="'Search saved filters'"
                    [ariaLabel]="'Search saved filters'"
                    [(ngModel)]="searchText"
                    (ngModelChange)="setFilteredListItems()"
                ></agpr-text-input>
                <div class="agpr-manageSavedFiltersDialog-toolbar">
                    <agpr-button
                        [id]="id + '_selectToggle'"
                        class="agpr-manageSavedFiltersDialog-selectAll"
                        [style]="buttonTypes.link"
                        [label]="allFiltersSelected ? 'selectNone' : 'selectAll'"
                        (click)="toggleSelectAll()"
                    ></agpr-button>
                    <div class="agpr-manageSavedFiltersDialog-toolbar-buttons">
                        <agpr-button
                            [id]="id + '_sortDirection'"
                            [style]="buttonTypes.icon"
                            [icon]="sortOrder === sortOrderEnum.ascending ? 'fa-regular fa-arrow-down-short-wide' : 'fa-regular fa-arrow-up-wide-short'"
                            tooltip="Sort"
                            tooltipPosition="top"
                            (click)="toggleSortOrder()"
                        ></agpr-button>
                        <agpr-button
                            [id]="id +' _create'"
                            class="agpr-manageSavedFiltersDialog-create"
                            [style]="buttonTypes.icon"
                            [icon]="'fa-regular fa-duotone fa-square-plus'"
                            tooltip="Create"
                            tooltipPosition="top"
                            (click)="openSavedFilterSetupDialog()"
                        ></agpr-button>
                    </div>
                </div>
            </div>
            <agpr-scroll-panel>
                <div class="agpr-manageSavedFiltersDialog-listContainer">
                    @if (hasFavoriteItems) {
                        <label class="agpr-manageSavedFiltersDialog-list-label"> {{ 'Common.filter.savedFilters.favorites' | localize }} </label>
                        <ul class="agpr-manageSavedFiltersDialog-list">
                            @for (item of filteredItems; track item.id; let i = $index) {
                                @if (item.favorite) {
                                    <ng-container
                                        *ngTemplateOutlet="filterCard, context: {item: item, index: i}"
                                    ></ng-container>
                                }
                            }
                        </ul>
                    }

                    <label class="agpr-manageSavedFiltersDialog-list-label"> {{ 'Common.filter.savedFilters' | localize }} </label>
                    <ul class="agpr-manageSavedFiltersDialog-list">
                        @for (item of filteredItems; track item.id; let i = $index) {
                            <ng-container
                                *ngTemplateOutlet="filterCard, context: {item: item, index: i}"
                            ></ng-container>
                        }
                    </ul>
                </div>
            </agpr-scroll-panel>
        </agpr-tab>
    </agpr-tabs>

    <ng-template #filterCard let-item="item" let-i="index">
        <li
            [id]="id + '_filterCard_' + i"
            class="agpr-manageSavedFiltersDialog-card agpr-contextMenu-parent"
        >
            <div class="agpr-manageSavedFiltersDialog-card-info">
                <span
                    class="agpr-manageSavedFiltersDialog-card-info-icon fa-regular fa-circle-info"
                    [agprTooltip]="'Source.manageDialog.sourceInformation' | localize: {
                        createdBy: item.createdBy,
                        createdDate: item.created,
                        modifiedBy: item.modifiedBy,
                        modifiedDate: item.modified
                    }"
                    tooltipPosition="left"
                ></span>
            </div>
            <div class="agpr-manageSavedFiltersDialog-card-content">
                <agpr-checkbox
                    [id]="id + '_filterCard_' + i + '_selected'"
                    [binary]="true"
                    [(ngModel)]="item.selected"
                    (ngModelChange)="checkForSelected()"
                ></agpr-checkbox>
                <div class="agpr-manageSavedFiltersDialog-card-name"> {{ item.name }} </div>
            </div>

            <ul class="right bottom agpr-contextMenu">
                <li>
                    <agpr-button
                        [id]="id + '_filterCard_' + i + '_favorite'"
                        [style]="buttonTypes.contextMenu"
                        [icon]="item.favorite ? 'fa fa-star' : 'fa-regular fa-star'"
                        [tooltip]="item.favorite ? 'Common.filter.savedFilters.removeFavorites' : 'Common.filter.savedFilters.addFavorites'"
                        tooltipPosition="top"
                        class="contextMenu"
                        (click)="editFavorite(item)"
                    ></agpr-button>
                </li>
                <li>
                    <agpr-button
                        [id]="id + '_filterCard_' + i + '_edit'"
                        [style]="buttonTypes.contextMenu"
                        [icon]="'fa-regular fa-duotone fa-pen'"
                        tooltip="Edit"
                        class="contextMenu"
                        tooltipPosition="top"
                        (click)="openSavedFilterSetupDialog(item)"
                    ></agpr-button>
                </li>
                <li>
                    <agpr-button
                        [id]="id + '_filterCard_' + i + '_delete'"
                        [style]="buttonTypes.contextMenu"
                        [icon]="'fa-regular fa-duotone fa-trash-can'"
                        tooltip="Delete"
                        class="contextMenu"
                        tooltipPosition="top"
                        (click)="openDeleteConfirmationDialog([item])"
                    ></agpr-button>
                </li>
            </ul>
        </li>
    </ng-template>
    <ng-template #footerRight>
        <agpr-button
            [id]="id + '_deleteButton'"
            [label]="'delete'"
            [disabled]="selectedItems.length <= 0"
            [style]="buttonTypes.primaryB"
            (click)="openDeleteConfirmationDialog(this.selectedItems)"
        ></agpr-button>
        <agpr-button
            [id]="id + '_applyButton'"
            [label]="'done'"
            [style]="buttonTypes.primary"
            (click)="closeDialog()"
        ></agpr-button>
    </ng-template>
</agpr-dialog-container>
